import React, { useState } from "react";

import { Divider, FormControlLabel, List, ListItem, Radio, RadioGroup, Typography } from "@material-ui/core";

import clsx from "clsx";

import makeStyles from "hooks/makeStyles";
import { DeliveryOrPickupAtControllerProps } from "hooks/useDeliveryOrPickupAtController";
import useTranslation from "hooks/useTranslation";

const useStyles = makeStyles(theme => ({
	itemDivider: {
		marginTop: theme.spacing(3),
		backgroundColor: "#f2f2f2"
	},
	weekDaysPanels: {
		fontFamily: "Gotham",
		fontWeight: "normal",
		display: "flex",
		justifyContent: "start",
		padding: "19px 4px 9px 4px",
		width: "100%",
		overflowX: "scroll",

		"&::-webkit-scrollbar": {
			background: "transparent"
		}
	},
	weekDaysPanel: {
		cursor: "pointer",
		fontSize: "12px",
		marginRight: "24px",
		display: "flex",
		flexDirection: "column",
		// background: "#C1C1C1",
		background: "#F8F8F8",
		color: theme.palette.text.primary,
		minWidth: "48px",
		width: "48px",
		height: "48px",
		borderRadius: "8px",
		padding: "8px 0",
		textAlign: "center",
		textTransform: "uppercase",

		"&:last-child": {
			marginRight: "0 !important"
		},

		"&.active": {
			// background: "#4F4F4F",
			// color: "#C1C1C1"
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText
		}
	},
	weekDaysPanelText: {
		fontSize: "12px"
	},
	weekDaysPanelTextDate: {
		fontWeight: 500
	},
	timeRange: {
		maxWidth: "inherit",
		display: "block",
		maxHeight: "128px",
		overflowY: "auto",
		fontWeight: 300,
		color: "#BDBDBD",
		paddingRight: "10px",
		marginRight: "-10px"
	},
	timeRangeLabel: {
		minWidth: "100%",
		display: "flex",
		justifyContent: "space-between",
		borderTop: "1px solid #BDBDBD",
		marginLeft: 0,
		marginRight: 0,
		paddingLeft: "14px",
		paddingRight: "6px",
		"& span": {
			fontSize: "12px"
		}
	},
	radio: {
		padding: "10px",
		color: "#f2f2f2",
		"&$checked": {
			color: theme.palette.primary.main
		},
		borderColor: "#fff"
	},
	checked: {
		padding: "5px"
	},
	radioIcon: {
		borderRadius: "50%",
		width: 14,
		height: 14,
		border: "1px solid #f2f2f2"
	}
}));

const OrderTimeSelectorRendererMobile = ({ items, selection, setValue }: DeliveryOrPickupAtControllerProps) => {
	const [date, setDate] = useState(selection.date);
	const { t } = useTranslation();
	const classes = useStyles();

	const selectedItem = items.find(x => x.value === date) || selection.item;

	return (
		<>
			<Divider className={classes.itemDivider} />

			<List className={classes.weekDaysPanels}>
				{items.map(item => (
					<ListItem
						key={item.value}
						className={clsx(classes.weekDaysPanel, { active: item.value === date })}
						onClick={() => setDate(item.value)}
					>
						<Typography className={classes.weekDaysPanelText}>{item.wd}</Typography>
						<Typography className={clsx(classes.weekDaysPanelText, classes.weekDaysPanelTextDate)}>
							{item.day}
						</Typography>
					</ListItem>
				))}
			</List>

			<RadioGroup
				className={classes.timeRange}
				aria-label="option"
				value={selection.value}
				onChange={event => setValue(event.target.value)}
			>
				{selectedItem.times.map(x => (
					<FormControlLabel
						key={x.value}
						className={classes.timeRangeLabel}
						value={x.value}
						control={
							<Radio
								inputProps={{ "aria-label": x.value }}
								icon={<span className={classes.radioIcon} />}
								classes={{ root: classes.radio, checked: classes.checked }}
								color="secondary"
							/>
						}
						label={x.text || t("asap")}
						labelPlacement="start"
					/>
				))}
			</RadioGroup>
		</>
	);
};

export default OrderTimeSelectorRendererMobile;
